import { StaticProvider } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { CUSTOM_LOADED_WIDGET_SKELETON, WIDGET_SKELETON } from '@frontend/sports/widget/core/feature';
import { of } from 'rxjs';

import { FavouritesWidgetSkeletonComponent } from './favourites-widget-skeleton.component';

export function provideFavouritesWidgetSkeleton(): StaticProvider {
    return {
        provide: WIDGET_SKELETON,
        useValue: {
            type: WidgetType.FavouritesGrid,
            component: FavouritesWidgetSkeletonComponent,
            config: () => of({ visible: true }),
        },
        multi: true,
    };
}

export function provideFavouritesWidgetSkeletonCustomLoad(): StaticProvider {
    return {
        provide: CUSTOM_LOADED_WIDGET_SKELETON,
        useValue: WidgetType.FavouritesGrid,
        multi: true,
    };
}
